import {deleteSendsPage, SendsPageItemType, SendsPagesUpdateType, useUpdateSendsData} from "@twigsby/client-data";
import {Button, ColourSolid, Modal, ModalType} from "@twigsby/frontend-framework";
import {useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";

interface ConfirmDeletePageType extends ModalType {
    pageData: SendsPageItemType
}

const ConfirmDeleteSendsPageModal = (props: ConfirmDeletePageType) => {
    const { t } = useTranslation();
    const updateSendsData = useUpdateSendsData();
    const [deletingPage, setDeletingPage] = useState<boolean>(false);

    const HandleDelete = async (pageId: number) => {
        if(pageId === -1) return;

        setDeletingPage(true);

        await deleteSendsPage(pageId).then(() => {
            updateSendsData.mutate({
                updateType: SendsPagesUpdateType.DELETE,
                newData: {id: pageId},
            });

            if(props.actionedCallback) {
                props.actionedCallback();
            } else {
                props.closeCallback();
            }
        }).catch((e) => {
            console.error(e.response.data);
        }).finally(() => setDeletingPage(false))
    }

    return (
        <Modal title={t('actions.deleteItem', { item : props.pageData?.title})} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
            <p>{t('messages.deleteConfirm')}</p>
            <Button
                loading={deletingPage}
                title={t('actions.delete')}
                colour={ColourSolid.Alert}
                fullWidth={true}
                onClick={() => HandleDelete(props.pageData?.id ?? -1)}
            />
        </Modal>
    )
}

export default ConfirmDeleteSendsPageModal
